import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { fetchUnderlyingHistoEpic } from './fetchUnderlyingHistoEpic';

export const underlyingsHistoricsEpic = () =>
  withAppCrashIfException(
    'underlyingsHistorics',
    combineEpics(withAppCrashIfException('fetchUnderlyingHistoEpic', fetchUnderlyingHistoEpic())),
  );
